<div *ngIf="shop$ | async as shop" class="shop" [ngClass]="{ disable: disable$ | async }">
  <div *ngIf="isMyShop$ | async" class="shop-my-shop">
    <cx-icon [type]="iconType.STAR"></cx-icon>
    <span>Мой магазин</span>
  </div>

  <div class="shop-address">{{ shop.addressFormatted }}</div>
  <div *ngIf="shop.scheme" class="shop-scheme">
    <a (click)="openModal()" class="text">схема склада</a>
  </div>
  <div class="shop-worktime">
    <sd-shop-working-time [shop]="shop"></sd-shop-working-time>
  </div>

  <div class="shop-available">
    <ng-container *ngIf="shop.pickupDate && (shop.pickupDate | uiTodayTomorrowDate: 'd MMMM') as pickupDate">
      <span [class]="pickupDate === 'сегодня' ? 'available' : 'not-available'">{{ ' ' }}Доступно {{ pickupDate }}</span>
    </ng-container>
    <ng-template #pickupDateEmpty>
      <span>{{ ' ' }}Дату самовывоза уточнит оператор</span>
    </ng-template>
  </div>
</div>
